module.exports = __webpack_public_path__ + "img/img48.6596678e.png";